import type { FormSection } from 'src/types/form-config.types';

import { MultiSelectAutocomplete } from 'src/pages/tickets/components/custom-multiSelect';

/**
 * Account Form Configuration
 *
 * JSON-driven field configuration for Account forms
 */

export const accountFormConfig: FormSection[] = [
  {
    title: 'BASIC_INFORMATION',
    fields: [
      {
        name: 'name',
        label: 'ACCOUNT_NAME',
        type: 'text',
        required: true,
        placeholder: 'ENTER_ACCOUNT_NAME',
        gridSize: { xs: 12, md: 12 },
      },
      {
        name: 'email',
        label: 'EMAIL',
        type: 'email',
        required: true,
        placeholder: 'ENTER_EMAIL',
        gridSize: { xs: 12, md: 12 },
      },
      {
        name: 'phone',
        label: 'PHONE_NUM',
        type: 'phone',
        required: true,
        placeholder: 'ENTER_PHONE_NUM',
        gridSize: { xs: 12, md: 12 },
      },
    ],
  },
  {
    title: 'ADDRESS_INFORMATION',
    fields: [
      {
        name: 'city',
        label: 'CITY',
        type: 'text',
        required: false,
        placeholder: 'ENTER_CITY',
        gridSize: { xs: 12, md: 12 },
      },
      {
        name: 'country',
        label: 'COUNTRY',
        type: 'text',
        required: false,
        placeholder: 'ENTER_COUNTRY',
        gridSize: { xs: 12, md: 12 },
      },
      {
        name: 'crNumber',
        label: 'CR_NUMBER',
        type: 'text',
        required: false,
        placeholder: 'ENTER_CR_NUMBER',
        gridSize: { xs: 12, md: 12 },
      },
      {
        name: 'pincode',
        label: 'PINCODE',
        type: 'text',
        required: false,
        placeholder: 'ENTER_PINCODE',
        gridSize: { xs: 12, md: 12 },
      },
      {
        name: 'website',
        label: 'WEBSITE',
        type: 'text',
        required: false,
        placeholder: 'ENTER_WEBSITE',
        gridSize: { xs: 12, md: 12 },
      },
      {
        name: 'address',
        label: 'ADDRESS',
        type: 'text',
        required: false,
        placeholder: 'ENTER_ADDRESS',
        gridSize: { xs: 12, md: 12 },
      },
    ],
  },
  {
    title: 'ASSIGNMENT',
    fields: [
      {
        name: 'assignUsers',
        label: 'ASSIGNED_TO',
        type: 'multiAssign',
        required: true,
        component: MultiSelectAutocomplete,
        componentProps: {
          placeholder: 'ADD_RECIPIENTS',
          isOptionEqualToValue: (a: any, b: any) => a.id === b.id,
        },
        gridSize: { xs: 12, md: 12 },
      },
    ],
  },
];

/**
 * Get field list for validation
 */
export function getAccountFieldList() {
  const fields: Array<{ name: string; required: boolean }> = [];

  accountFormConfig.forEach((section) => {
    section.fields.forEach((field) => {
      fields.push({
        name: field.name,
        required: field.required || false,
      });
    });
  });

  return fields;
}
